import { render, staticRenderFns } from "./DialogBatchHistory.vue?vue&type=template&id=45c9ca22"
import script from "./DialogBatchHistory.vue?vue&type=script&lang=js"
export * from "./DialogBatchHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports